import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { connect } from 'react-redux';
import { apiAction, pageContext } from 'ctm-util-functions';

// manor
import { Button } from '@comparethemarketau/manor-button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt } from '@fortawesome/pro-regular-svg-icons';
import { MobileLayout } from '@comparethemarketau/manor-layout';
import { withQuoteFlatten } from './with_quote_flatten';
import { ProductGetInTouchModal } from '../widget/product_get_in_touch_modal';

const useStyles = createUseStyles((theme) => ({
    container: {
        marginBottom: theme.spacing[12]
    },
    button: {
        height: theme.spacing[48],
        marginBottom: 0
    },
    phoneIcon: {
        marginRight: '0.5rem',
        size: '1.6rem'
    }
}));

const _GetInTouch = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { contactIsCallBackAllowed, contactIsCallDirectAllowed, quote, providerName, productId, className, onClickGetInTouch, buttonClassName } = props;

    const isButtonVisible = contactIsCallDirectAllowed || contactIsCallBackAllowed;
    const [modalVisible, setModalVisible] = useState(false);

    /**
     * request:
     *  car-insurance/journey/reporter -> /packages/ctm-app/client/api.js postReporter
     *  and car-journey/event
     */
    const handleClick = () => {
        setModalVisible(true);
        onClickGetInTouch(productId);
    };

    const handleModalClose = () => {
        setModalVisible(false);
    };

    return (
        isButtonVisible ? (
            <div className={classNames('test-policyProductCard-getInTouch', classes.container, className)}>
                <Button
                    id={`get-in-touch-button-${productId}`}
                    trackingLabel={`Get in touch with ${providerName} for ${productId}`}
                    variant="secondary"
                    handleClick={handleClick}
                    className={classNames(classes.button, buttonClassName)}
                >
                    <MobileLayout className={classes.phoneIcon}><FontAwesomeIcon icon={faPhoneAlt} /></MobileLayout>
                    Get in touch
                </Button>
                <ProductGetInTouchModal quote={quote} visible={modalVisible} onClose={handleModalClose} />
            </div>
        ) : null
    );
};

_GetInTouch.propTypes = {
    className: PropTypes.string,
    buttonClassName: PropTypes.string,

    quote: PropTypes.object.isRequired,
    contactIsCallBackAllowed: PropTypes.bool,
    contactIsCallDirectAllowed: PropTypes.bool,
    productId: PropTypes.string,
    providerName: PropTypes.string,

    onClickGetInTouch: PropTypes.func
};

// see packages/ctm-components/components/call_options/call_us/call_us.js
const mapDispatchToProps = (dispatch) => {
    const apiSchema = {
        url: '/event',
        requestAction: 'CALL_DIRECT',
        type: 'POST',
        requestPayload: 'lead',
        failureType: 'non-fatal'
    };
    return {
        onClickGetInTouch: (productId) => {
            const requestPayload = {
                productId
            };
            dispatch(apiAction(
                apiSchema,
                pageContext.getProps().pageState,
                [],
                apiSchema.baseUrlName,
                requestPayload
            ));
        }
    };
};

const GetInTouch = withQuoteFlatten(connect(null, mapDispatchToProps)(_GetInTouch));

export { GetInTouch };
